/* window.BotPartner: оболочка собрана компонентом, контракт PAGES тот же (init, mount, fill, after, focus, balanceChanged).
   Серверный режим — тот же раздел шаблона с данными partner-server.ts; демо-флаги и служебное меню тестов в нём не работают. */
import { definePageModule } from '../../bridge/page-module';
import { Partner } from './Partner';
import { createPartner } from './engine';
import { isServerMode } from '../../platform/server-mode';
import { createPartnerServer } from './partner-server';

const SKIP = new Set(['markup', 'prepare', 'attach', 'init', 'unmount', 'S', 'fill', 'after', 'serve', 'PREFIX', 'TESTS', 'mounted']);

export interface PartnerView {
  body: string;
}

export interface PartnerApi {
  prepare: () => PartnerView;
  attach: () => void;
  init: (o: BotPageUi) => void;
  unmount: () => void;
  fill: (...args: unknown[]) => void;
  after: () => void;
  serve: (make: typeof createPartnerServer) => void;
  S: object;
  PREFIX: string;
  TESTS: [string, [string, string][]][];
}

let api: PartnerApi;

/** Экран берёт api при отрисовке: installPartner уже вызван */
export function partnerApi() {
  return api;
}

/** Методы и геттеры раздела, кроме тех, что забирает контракт страницы */
function liveExtras(b: object): Record<string, unknown> {
  const extra: Record<string, unknown> = {};
  for (const [k, d] of Object.entries(Object.getOwnPropertyDescriptors(b))) {
    if (SKIP.has(k)) continue;
    if (d.get) Object.defineProperty(extra, k, { enumerable: true, get: () => (b as Record<string, unknown>)[k] });
    else if (typeof d.value === 'function') {
      const fn = d.value as (...args: unknown[]) => unknown;
      extra[k] = (...args: unknown[]) => fn.apply(b, args);
    } else extra[k] = d.value;
  }
  return extra;
}

export function installPartner() {
  const b = createPartner() as unknown as PartnerApi;
  const server = isServerMode();
  if (server) b.serve(createPartnerServer);
  api = b;
  definePageModule({
    global: 'BotPartner',
    PREFIX: b.PREFIX,
    TESTS: server ? [] : b.TESTS,
    S: b.S,
    Page: Partner,
    init(o) {
      b.init(o);
    },
    fill(...args: unknown[]) {
      if (!server) b.fill(...args);
    },
    after() {
      if (!server) b.after();
    },
    beforeUnmount() {
      b.unmount();
    },
    extra: liveExtras(b),
  });
}
